import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import inputMethod from "../lib/inputMethod";

// FocusHandler contains all of the logic necessary to determine whether an
// element is focused and the input method used to focus the element.
// You just have to bring your own element.
//
// FocusHandler passes two arguments to its children:
//
//   props - The props necessary to determine the focus of an element.
//     These props should be passed to the focusable element.
//
//   method - The input method used to focus the element.
//     If the input method is null, the element is not focused.
//
// FocusHandler is the first example of an experimental pattern to define
// reusable components that encapsulate stateful logic without rendering any
// output. In the future, these can potentially be powered by React hooks.
// Questions? Ping @koop in #sail.
var FocusHandler = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusHandler, _React$Component);

  var _super = _createSuper(FocusHandler);

  function FocusHandler() {
    var _this;

    _classCallCheck(this, FocusHandler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      method: null
    };

    _this.onFocus = function (event) {
      if (_this.props.stopPropagation) {
        event.stopPropagation();
      }

      _this.setState(function () {
        return {
          method: inputMethod.getState()
        };
      });
    };

    _this.onBlur = function (event) {
      if (_this.props.stopPropagation) {
        event.stopPropagation();
      }

      _this.setState({
        method: null
      });
    };

    return _this;
  }

  _createClass(FocusHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      inputMethod.mount();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      inputMethod.unmount();
    }
  }, {
    key: "render",
    value: function render() {
      var onBlur = this.onBlur,
          onFocus = this.onFocus;
      return this.props.children({
        onBlur: onBlur,
        onFocus: onFocus
      }, this.state.method);
    }
  }]);

  return FocusHandler;
}(React.Component);

export default FocusHandler;